import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import config from './aws-exports';

// Configure Amplify at the app level before any components render
Amplify.configure({
  Auth: {
    region: config.aws_project_region,
    identityPoolId:  process.env.AMPLIFY_IDENTITYPOOL_ID || config.aws_cognito_identity_pool_id ||"ap-south-1:b30f29e4-4507-49a7-9d70-29c35d5a0f28",
    userPoolId: process.env.AMPLIFY_USERPOOL_ID || config.aws_user_pools_id,
    userPoolWebClientId: process.env.AMPLIFY_WEBCLIENT_ID || config.aws_user_pools_web_client_id,
    oauth: {
      domain: process.env.REACT_APP_AMTPL_SSO_DOMAIN || config.oauth?.domain || 'auth-devlab.grainsglobaldev.com',
      scope: ['email', 'phone', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
      redirectSignIn: window.location.origin + '/',
      redirectSignOut: window.location.origin + '/',
      responseType: 'code'
    }
  },
  Storage: {
    AWSS3: {
      bucket: config.aws_user_files_s3_bucket,
      region: config.aws_project_region
    }
  },
  API: {
    GraphQL: {
      endpoint: config.aws_appsync_graphqlEndpoint,
      region: config.aws_appsync_region,
      defaultAuthMode: config.aws_appsync_authenticationType
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();